module.exports = __webpack_public_path__ + "img/deviceBorrow-mine-bar-2.25f0f73b.png";